import React, { useState, useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  View,
  SafeAreaView,
  TextInput,
  TouchableOpacity,
  Alert,
  Image,
  StyleSheet,
  Text,
} from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { useNavigation } from '@react-navigation/native';
import { useAuth } from '../config/AuthContext'; // Importe o useAuth
import config from '../config/config';
import Constants from 'expo-constants';

const LoginScreen = () => {
  const [loginID, setLoginID] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  // Obtenha o setMaquinaId para armazenar para manipular em outras telas a maquinaId
  const { setMaquinaId } = useAuth();
  const appVersion = Constants.manifest.version;
  //Url de conxão com o seriviço da Azure
  // const azureUrl = 'http://localhost:3001/api';

  const tableName = 'equipstates';
  const navigation = useNavigation();

  useEffect(() => {
    // Recupera o loginID armazenado no AsyncStorage e configura o estado
    const getStoredID = async () => {
      const storedID = await AsyncStorage.getItem('maquinaId');
      if (storedID) {
        setLoginID(storedID);
      }
    };

    getStoredID();
  }, []);

  //Tratamento de erros e verificação de Id existente da tabela
  const handleButtonPress = async () => {
    setLoading(true);

    //Filtro para buscar a maquinaId na tabela com o dado preenchido pelo usuário
    try {
      const tabelaEndpoint = `${config.apiBaseUrl}/tables/${tableName}?$filter=maquinaID eq '${loginID}'`;
      const response = await fetch(tabelaEndpoint, {
        headers: {
          'ZUMO-API-VERSION': '2.0.0',
        },
      });

      //Dados em JSON referente ao parametro de pesquisa maquinaId correspondente ao informado pelo usuário
      const data = await response.json();

      if (data.length > 0) {
        // Armazena o loginID no AsyncStorage
        await AsyncStorage.setItem('maquinaId', loginID);

        // A maquinaId será armazenada e mudará para a tela HomeScreen com a ID digitada pelo usuário armazenada
        setMaquinaId(loginID);
        navigation.navigate('HomeScreen');
      } else {
        setError('Licença não encontrada. Por favor, verifique o ID.');
      }
    } catch (error) {
      setError(
        'Ocorreu um erro ao processar sua sollicitação. Tente novamente.',
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <KeyboardAwareScrollView
      contentContainerStyle={styles.container}
      keyboardShouldPersistTaps="handled"
    >
      <View>
        <Image
          style={styles.logoMarrari}
          source={require('../assets/marrari.png')}
        />
        <Image style={styles.logoProx} source={require('../assets/prox.png')} />

        <Text style={styles.text}>ID Servidor</Text>
        <TextInput
          style={styles.input}
          placeholder="Digite seu ID"
          value={loginID}
          onChangeText={setLoginID}
        />

        <TouchableOpacity style={styles.button} onPress={handleButtonPress}>
          <Text style={styles.buttonTitle}>Entrar</Text>
        </TouchableOpacity>
        {error !== '' && <Text style={styles.errorText}>{error}</Text>}
      </View>
      <View style={styles.footer}>
        <Text>Versão {appVersion}</Text>
      </View>
    </KeyboardAwareScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#CCCCCA',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoMarrari: {
    width: 230,
    height: 80,
    marginBottom: 50,
    alignSelf: 'center',
  },
  logoProx: {
    width: 360,
    height: 142,
    marginBottom: 80,
  },
  text: {
    color: '#41403F',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 25,
    alignSelf: 'center',
  },
  input: {
    width: 310,
    height: 50,
    backgroundColor: '#F3F3F1',
    borderRadius: 20,
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 24,
    alignSelf: 'center',
  },
  button: {
    backgroundColor: '#FFCB05',
    width: 150,
    height: 40,
    borderRadius: 20,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonTitle: {
    color: '#FBFAF8',
    fontSize: 22,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 50,
    backgroundColor: '#CCCCCA',
  },
  errorText: {
    color: 'red',
    fontSize: 16,
    textAlign: 'center',
    marginTop: 10,
  },
});

export default LoginScreen;
